import { jsx as _jsx } from "react/jsx-runtime";
export function Label({ style, ...props }) {
    return (_jsx("label", { style: {
            fontFamily: 'var(--font-family-body)',
            fontSize: '0.875rem', fontWeight: 700,
            color: 'var(--color-text-muted)',
            ...style,
        }, ...props }));
}
